import './style.css'
import { App } from './ui/app'
import { migrateFromBushuDrill } from './core/migrate'

const root = document.querySelector<HTMLElement>('#app')
if (!root) throw new Error('ไม่พบ #app')

async function boot(): Promise<void> {
  // ย้ายความคืบหน้าจาก bushu-drill.html เดิม — ทำครั้งเดียว
  await migrateFromBushuDrill()
  await new App(root as HTMLElement).mount()
}

void boot()
